export const BONKERS_LD_DATA = {
  '@context': 'http://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://www.bonkers.ie',
  url: 'https://www.bonkers.ie',
  logo: 'https://www.bonkers.ie/bonkers-logo.svg',
  image: 'https://www.bonkers.ie/bonkers-logo.svg',
  name: 'bonkers.ie',
  telephone: '+353-1-256-0540',
  address: {
    '@type': 'PostalAddress',
    'addressCountry': 'IE',
    'addressLocality': 'Dublin 4',
    'addressRegion': 'Leinster',
    'postalCode': 'D04T4A4',
    'streetAddress': 'Nutley Building, Nutley Lane'
  },
  brand: [{
    '@type': 'Brand',
    logo: 'https://www.bonkers.ie/bonkers-logo.svg',
    name: 'bonkers.ie'
  }],
  contactPoint: [{
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@bonkers.ie',
    telephone: '+353-1-256-0540'
  }],
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 53.318739,
    longitude: -6.213271
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      opens: '09:00',
      closes: '17:30',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday']
    },
    {
      '@type': 'OpeningHoursSpecification',
      opens: '09:00',
      closes: '17:00',
      dayOfWeek: ['Friday']
    }
  ]
};
